import { useMemo } from "react";
import WebchatThumb from "@/assets/svgs/icons/integration/webchat_thumb.svg";
import KakatalkThumb from "@/assets/svgs/icons/integration/kakaotalk_thumb.svg";
import NaverTalkThumb from "@/assets/svgs/icons/integration/navertalk_thumb.svg";
import SlackThumb from "@/assets/svgs/icons/integration/slack_thumb.svg";
import JandiThumb from "@/assets/svgs/icons/integration/jandi_thumb.svg";
import InstagramThumb from "@/assets/svgs/icons/integration/instagram_thumb.svg";
import FacebookThumb from "@/assets/svgs/icons/integration/facebook_thumb.svg";
import LineThumb from "@/assets/svgs/icons/integration/line_thumb.svg";


interface ChannelThumbProps {
    channel?: MessageChannel | string;
    className?: string;
    alt?: string;
}

const ChannelThumb: React.FC<ChannelThumbProps> = (props) => {
    const { channel, className, alt } = props;
    
    const thumbImage = useMemo(() => {
        switch (channel) {
            case "web":
                return WebchatThumb;
            case "kakaotalk":
                return KakatalkThumb;
            case "navertalk":
                return NaverTalkThumb;
            case "slack":
                return SlackThumb;
            case "jandi":
                return JandiThumb;
            case "instagram":
                return InstagramThumb;
            case "facebook":
                return FacebookThumb;
            case "line":
                return LineThumb;
            default:
                return;
        }
    }, [channel]);

    if (!thumbImage)
        return <>{channel ?? ""}</>;

    return (
        <img src={thumbImage} alt={alt ?? ""} className={className} />
    );
};

export default ChannelThumb;
